import { useEffect } from "react";
import Lenis from "lenis";

const LENIS_OPTIONS = { duration: 1.1, smoothWheel: true };

export function usePageScroll(pathname) {
  useEffect(() => {
    const lenis = new Lenis(LENIS_OPTIONS);
    let frame;
    const loop = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(loop);
    };
    frame = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
}